var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ToastUtils from '@/utils/ToastUtils';
const SCC_CONTENT_SHARE_SHORT_ID = 'scc-content';
// 장소 공유 트래킹링크(native ShareUtils.ts와 동일). fallback: web.staircrusher.club/place/{placeId}
const PLACE_SHARE_SHORT_ID = 'place';
function copyToClipboard(url) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield navigator.clipboard.writeText(url);
            ToastUtils.show('링크가 복사되었습니다.');
        }
        catch (_a) {
            ToastUtils.show('링크 복사에 실패했습니다.');
        }
    });
}
const ShareUtils = {
    // native와 동일한 트래킹링크(placeId만 실어 앱/web.staircrusher.club 열릴 때 라우팅).
    // 이전엔 현재 경로 기반 중첩 url(/place-list/:id/place/:id 등)을 복사했는데
    // webLinkingConfig에 없는 경로라 데스크톱에서 /home으로 튀었다.
    sharePlace(place) {
        return __awaiter(this, void 0, void 0, function* () {
            yield copyToClipboard(`https://link.staircrusher.club/${PLACE_SHARE_SHORT_ID}?placeId=${encodeURIComponent(place.id)}`);
        });
    },
    // 네이티브와 동일 시그니처. id 있으면 트래킹링크, 없으면 contentUrl을 클립보드에 복사.
    shareSccContent(sccContentId, contentUrl, _title) {
        return __awaiter(this, void 0, void 0, function* () {
            if (sccContentId) {
                yield copyToClipboard(`https://link.staircrusher.club/${SCC_CONTENT_SHARE_SHORT_ID}?sccContentId=${encodeURIComponent(sccContentId)}`);
                return;
            }
            yield copyToClipboard(contentUrl);
        });
    },
};
export default ShareUtils;
